import config from "../../config";
import { siteContextRequest } from "../../redux/siteContextRequest";
import { AppDispatch } from "../../store";

interface ISphericalCoords {
  x: number;
  y: number;
  z: number;
}

export interface IFlatCoords {
  x: number;
  y: number;
  z: number;
}

export interface IFlightMarker {
  id: string;
  name: string;
  // TODO: seems that we haven't used it, remove
  sitterName: string;
  // Name of person, who process information about this nail, can be name or email
  operatorName: string;

  // Original coordinates
  sitterCoords: IFlatCoords;
  // Coordinates for CAD systems, can be the same as original
  operatorCoords: IFlatCoords;
  // Coordinates in WGS 84 for Google Map/Leaflet/etc
  mapCoords: ISphericalCoords;

  // Creation timestamp
  tsCreated: number;
  // Archivation time, timestamp, can be empty
  tsArchived?: number;
  // Flag that this point is used as Quality Control point
  isQC: boolean;
}

export const fetchFlightMarkeres = (
  customerId: string,
  siteId: string,
) => async (dispatch: AppDispatch): Promise<IFlightMarker[]> => {
  const bapiResponse = await dispatch(
    siteContextRequest(customerId, siteId, {
      method: "GET",
      url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/flight-markers`,
    }),
  );
  return bapiResponse.data.flightMarkers;
};
